var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.646 23.354a.5.5 0 1 0 .708-.708L12.707 12 23.353 1.354a.5.5 0 1 0-.707-.708L12 11.293 1.354.646a.5.5 0 0 0-.708.708L11.293 12 .646 22.646a.5.5 0 1 0 .708.708L12 12.707l10.646 10.646Z",
  fill: "#000"
})));
export default SvgCloseinline;